import { useRef, useState } from 'react';
import {
  CollectMethodPaymentType,
  PagoTictCollectMethod,
} from '../../../types';
import { Column } from '../../common/Column';
import { FullPageSpinner } from '../../common/FullPageSpinner';
import { useResponsive } from '../../../hooks/useResponsive';
import { featureFlags } from '../../../featureFlags';
import {
  undoPagoticIssuedKey,
  useInvoiceById,
} from '../../../features/checkout/checkoutQueries';
import { useCheckoutParams } from '../../../features/checkout/useCheckoutParams';
import { PayerEmailInput } from './PayerEmailInput';
// import { RetryButton } from './RetryButton';
import { useIsMutating } from '@tanstack/react-query';

export interface PagoTicFormProps {
  collectMethod: PagoTictCollectMethod;
  pagoticId: string;
  paymentCategory: CollectMethodPaymentType;
}

const PAGOTIC_BASE_URL = 'https://macro.paypertic.com/app/';
const PAGOTIC_TYPES: Record<CollectMethodPaymentType, string> = {
  card: 'online',
  ticket: 'coupon',
  qr: 'qr',
  cbu: 'cbu',
  debin: 'debin',
  transfer: 'transfer',
};

// TODO: Change this into STYLE_BY_PAYMENT_TYPE for more customization
const HEIGHT_BY_PAYMENT_TYPE: Record<CollectMethodPaymentType, string> = {
  card: '492px',
  ticket: '488px',
  qr: '338px',
  cbu: '660px',
  debin: '500px',
  transfer: '338px',
};

export function PagoTicForm({
  pagoticId: pagoticIdProp,
  paymentCategory,
}: PagoTicFormProps): JSX.Element {
  // const [refetchInterval, setRefetchInterval] = useState<number | false>(1000);
  const isUndoing = !!useIsMutating({ mutationKey: undoPagoticIssuedKey });
  const ref = useRef<HTMLIFrameElement>(null);
  const { isMobile } = useResponsive();
  const [iframeLoading, setIframeLoading] = useState(true);
  const pagoticId = featureFlags.pagoticId || pagoticIdProp;
  const iframeId = `pagotic-${pagoticId}-${paymentCategory}`;
  const url = `${PAGOTIC_BASE_URL}${pagoticId}/${PAGOTIC_TYPES[paymentCategory]}`;
  const { invoiceId } = useCheckoutParams();

  const isLoading = iframeLoading || isUndoing;

  // add refetch interval to invoice so that the checkout is updated when the payment is approved
  // TODO: refetch also for subscriptions
  // TODO: modify refetchInterval according to user interactions
  const { data: invoice } = useInvoiceById(invoiceId, {
    refetchInterval: 1000,
  });
  const paymentFailed = invoice?.pagotic_payment_status === 'rejected';

  // const reloadIframe = useCallback(() => {
  //   setIframeLoading(true);
  //   setRefetchInterval(1000);
  //   const iframe = document.getElementById(
  //     iframeId
  //   ) as HTMLIFrameElement | null;
  //   if (iframe) {
  //     iframe.src = url;
  //   }
  // }, [iframeId, url]);

  const iframeWidth = isMobile ? '100%' : '351px';
  const iframeHeight = HEIGHT_BY_PAYMENT_TYPE[paymentCategory];

  return (
    <div ref={ref} style={{ width: iframeWidth }}>
      <Column marginTop="16px">
        {!paymentFailed && <PayerEmailInput invoiceId={invoiceId} />}

        {isLoading && (
          <div
            style={{
              width: iframeWidth,
              height: iframeHeight,
            }}
          >
            <FullPageSpinner />
          </div>
        )}
        {!isUndoing && (
          <iframe
            id={iframeId}
            title="formulario de pago"
            src={url}
            allow="web-share"
            style={{
              width: iframeWidth,
              height: iframeHeight,
              display: isLoading ? 'none' : 'block',
            }}
            onLoad={() => setIframeLoading(false)}
          />
        )}

        {/* {paymentFailed && !isLoading && (
          <RetryButton
            invoiceId={invoiceId}
            onSuccess={reloadIframe}
            onClick={() => setRefetchInterval(0)}
          />
        )} */}
      </Column>
    </div>
  );
}
// Rutas disponibles

// -Pagos con tarjeta: /app/:id/online

// -Pagos en efectivo: /app/:id/coupon

// -Pagos con QR: /app/:id/qr

// -Pantalla inicial (register) con botones de medios de pago: /app/:id/checkout

// -Comprobante de pago en pagos aprobados: /app/:id/checkout/ticket
